import { sharePointDriveService } from '@/services/sharepoint-drive/sharepoint-drive-service';
import { fileKeys } from '@/utils/queryKeys';
import { useQuery } from '@tanstack/vue-query';
import { computed, toValue, type MaybeRefOrGetter } from 'vue';
import type { FileSystemItem } from '../types';

export const useFileItemDetailsQuery = (item: MaybeRefOrGetter<FileSystemItem | null>) => {
  const driveId = computed(() => toValue(item)?.driveId);
  const itemId = computed(() => toValue(item)?.id);

  return useQuery({
    queryKey: computed(() => fileKeys.details(driveId.value ?? '', itemId.value ?? '')),
    queryFn: () => sharePointDriveService.getItemDetails(driveId.value!, itemId.value!),
    // Not withRetry-wrapped at the service, so vue-query's default retry:3 (from the app-level
    // QueryClient's lack of overrides) would be the sole retry layer here. Disable it: an
    // enrichment failure should fall back to missing details immediately, not after ~7s.
    retry: false,
    enabled: computed(() => {
      const current = toValue(item);
      return (
        !!current &&
        current.type === 'file' &&
        !!driveId.value &&
        !!itemId.value
      );
    }),
  });
};
